import * as React from 'react';
import { IconProps } from '../types';

const IcList = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
   <g fill={props?.fill ?? '#232F3E'} clipPath="url(#a)">
      <path d="M3.822 16.298a1.756 1.756 0 1 0 .003 3.512 1.756 1.756 0 0 0-.003-3.512ZM3.822 9.748a1.754 1.754 0 1 0 .004 3.508 1.754 1.754 0 0 0-.004-3.508ZM3.821 3.198a1.756 1.756 0 1 0 0 3.512 1.756 1.756 0 0 0 0-3.512ZM21.288 3.746H8.19a1.212 1.212 0 1 0 0 2.424h13.098a1.212 1.212 0 1 0 0-2.424ZM21.288 10.292H8.19a1.212 1.212 0 1 0 0 2.423h13.098a1.212 1.212 0 1 0 0-2.423ZM21.289 16.847h-13.1a1.211 1.211 0 0 0 0 2.422h13.1a1.21 1.21 0 1 0 0-2.422Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.283 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcList;